import axios from 'axios'

export default {
  fetchOrders (url) {
    return axios.get(url)
  },
  fetchDraftOrdersList (url) {
    return axios.get(url)
  },
  updateOrders (id, payload) {
    return axios.patch(`/api/order/${id}/update`, payload)
  },
  deleteOrderById (orderId) {
    return axios.delete(`/api/order/delete-draft-order/${orderId}`)
  },
  getUnitSummaryReportData (orderId) {
    return axios.get(`/api/order/get-unit-summary-report-data/${orderId}`)
  },
  removeProduct (payload) {
    return axios.post('/api/order/remove-product', payload)
  },
  bulkDeleteDraftOrder (payload) {
    return axios.delete('/api/order/bulk-delete-draft-order', payload)
  },
  newOrder (payload) {
    return axios.post('/api/order', payload)
  },
  getNewOrderModalData () {
    return axios.get('/api/order/get-new-order-modal-data')
  },
  getOrderDetail (orderId) {
    return axios.get(`/api/order/detail/${orderId}`)
  },
  copyActiveOrderToNewOrder(payload) {
      return axios.post('/api/order/copy-to-new-order', payload)
  },
  duplicateOrder(sourceOrderId) {
      return axios.post('/api/order/duplicate', { source_order_id: sourceOrderId })
  },
  editRecreateOrder(sourceOrderId) {
      return axios.post('/api/order/edit-recreate', { source_order_id: sourceOrderId })
  },
  copyDraftOrderToOtherDraftOrder(payload) {
      return axios.post('/api/order/copy-to-draft-order', payload)
  },
  fetchExceedQuantitiesUnit(orderId) {
      return axios.get(`/api/checkout/proceed/${orderId}`)
  },
  addQuantityExceedProducts(payload) {
      return axios.post('/api/checkout/quantity-exceed', payload)
  },
  completeOrder(payload) {
      return axios.post('/api/order/complete', payload)
  },
  deleteProductNote(payload) {
     return axios.delete('/api/order/delete-product-notes', payload)
  },
  validateOrderedProduct(orderId)  {
      return axios.get(`/api/order/validate-ordered-product/${orderId}`)
  },
  updatePo(orderId, data) {
        return axios.put(`/api/order/${orderId}/po`, data);
  },
  getDigitalCatalogUnitSummaryReportData() {
      const accessToken = localStorage.getItem('digital_catalog_access_token')
      return axios.get('/api/digital-catalog/selected-product-summary', {
          headers: {
              'X-Access-Token': accessToken
          }
      })
  },
  addProductByDesignNumber(payload) {
    // Add module type for the centralized API
    const data = {
      ...payload,
      module: 'order'
    }
    return axios.post('/api/add-product-by-design-number', data)
  },
  refreshOrderInventory (orderId) {
    return axios.post('/api/checkout/order-summary/' + orderId + '/refresh-inventory')
  },
  downloadJpgImages (orderId) {
    return axios.get('/api/order/' + orderId + '/jpg-images', {
      responseType: 'blob'
    })
  }
}
